interface Filter {
    degreeType: string | null;
    parentCategory: string | null;
    category: string | null;
}

interface ResultRow {
    title: string;
    subTitle: string;
    resultType: 'filters' | 'filterKey';
    filterKey: string;
    filters: Filter;
}

export interface ClickPortalResultRowsSectionProps {
    background: string;
    variation: string;
    description: string;
    customCssClass: string;
    isReversed: string;
    textAlignment: string;
    title: string;
    subTitle: string;
    isCurated: boolean;
    resultRowsConfig: ResultRow[];
}

function transformResultRows(resultRows: ResultRow[]): ResultRow[] {
    return resultRows.map(row => {
        if (row.resultType === 'filterKey') {
            return {
                title: row.title || '',
                subTitle: row.subTitle || '',
                resultType: 'filterKey',
                filterKey: row.filterKey || '',
                filters: { degreeType: null, parentCategory: null, category: null }
            };
        }

        return {
            title: row.title || '',
            subTitle: row.subTitle || '',
            resultType: 'filters',
            filterKey: '',
            filters: {
                degreeType: row.filters?.degreeType || null,
                parentCategory: row.filters?.parentCategory || null,
                category: row.filters?.category || null
            }
        };
    });
}

export default function wpToClickPortalResultRowsSectionTransform(acfValues: ClickPortalResultRowsSectionProps): ClickPortalResultRowsSectionProps {
    return {
        background: acfValues.background || '',
        variation: acfValues.variation || '',
        description: acfValues.description || '',
        customCssClass: acfValues.customCssClass || '',
        isReversed: acfValues.isReversed || '',
        textAlignment: acfValues.textAlignment || '',
        title: acfValues.title || '',
        subTitle: acfValues.subTitle || '',
        isCurated: acfValues.isCurated || false,
        resultRowsConfig: transformResultRows(acfValues.resultRowsConfig || [])
    };
}
